<template>
  <div id="projectMember">
    <!-- 头部输入框 -->
    <div class="headerBox">
      <van-field class="input" clearable v-model="inputValue" placeholder="请输入关键词" @keydown.enter="inputConfirm" >
        <template #label>
          <Popover :actions="actions" @select="e => {actionValue = e;}" />
        </template>
      </van-field>
      <div class="cencel" @click="$router.back()">取消</div>
    </div>
    <!-- 多选筛选 -->
    <div class="filterBox">
      <div class="left">
        <div v-if="!tagsList.length" class="all">全部</div>
        <div class="list" v-else>
          <div class="item" v-for="(item,index) in tagsList" :key="index">
            <span>{{ item.name }}</span>
            <i class="icon icon-del" @click="delTag(index)"></i>
          </div>
        </div>
      </div>
      <div class="right" @click="popupOpen">
        <span>筛选</span>
        <img class="icon" :src="require('@/assets/images/research/icon_filter_01.png')" />
      </div>
    </div>
    <div class="container">
      <!-- 列表 -->
      <van-pullRefresh v-model="page.refreshing" @refresh="init">
        <Empty v-if="page.list === []" />
        <van-List
          v-else
          v-model="page.loading"
          :finished="page.finished"
          @load="onLoad"
          :key="page.totalCount"
        >
          <MemberItem v-for="item in page.list" :key="item.id" :detail="item" @handleClick="handleInvite" />
          <template #finished>
            <van-divider class="list-bottom-tip">滑到底啦</van-divider>
          </template>
        </van-List>
      </van-pullRefresh>
    </div>
    <!-- 抽屉 -->
    <van-popup v-model="popupShow" position="right" class="popupWrap">
      <div class="list">
        <div class="box" v-for="(item,index) in filterList" :key="index">
          <div class="title">{{ item.title }}：</div>
          <div class="child">
            <div class="item" :class="{'active':temporaryList.map(item => item.id).includes(v.id)}" v-for="(v,i) in item.list" :key="i" @click="handleTag(v)">{{ v.name }}</div>
          </div>
        </div>
      </div>
      <div class="btnWrap">
        <button @click="popupSubmit">确定</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Field } from 'vant';
import { Popover } from '@/components';
import MemberItem from './components/MemberItem';
export default {
  name: 'ProjectMember',
  components: { 'van-field': Field, Popover, MemberItem },
  data () {
    return {
      id: '',
      inputValue: '',
      keyword: '',
      showPopover: false,
      actions: [{ text: '手机号', id: 1 }, { text: '用户名', id: 2 }, { text: '邮件', id: 3 }],
      actionValue: { text: '手机号', id: 1 },
      tagsList: [],
      popupShow: false,
      filterList: [{ title: '学科', list: [] }],
      temporaryList: [],
      roleType: 2, // 2 普通成员；3管理员；4顾问
      page: {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      }
    };
  },
  mounted () {
    const { params: { id } } = this.$route;
    this.id = id;
    this.getSubjects();
  },
  methods: {
    inputConfirm () {
      this.keyword = this.inputValue;
      this.init();
    },
    init () {
      // 清空列表数据 重新加载数据
      this.page = {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      };
    },
    // 加载主列表
    onLoad () {
      const { id, page, actionValue, keyword, tagsList } = this;
      this.$http.get('studio/studioMembers', {
        params: {
          pageNo: page.pageNo,
          pageSize: page.pageSize,
          id,
          type: actionValue.id,
          keyword,
          subject: tagsList.length ? tagsList.map((item) => item.name).join(',') : ''
        },
        showLoading: true
      }).then((res) => {
        let data = res.data || {};
        page.list.push(...(data.memberList || []));
        page.pageNo++;
        page.totalCount = data.totalCount || 0;
        page.loading = false;
        page.finished = !data.isHasNext;
        page.refreshing = false;
      });
    },
    // 邀请成员
    handleInvite (item) {
      const { id, roleType } = this;
      this.$http.post('studio/inviteProjectMember', { id, members: [{ memberId: item.id, admin: item.admin }], roleType }, { showLoading: true }).then((res) => {
        this.$set(item, 'status', true);
      });
    },
    // 获取科目列表
    getSubjects () {
      this.$http.get('security/apple/info').then((res) => {
        this.filterList[0].list = res.data.subjects || [];
      });
    },
    // 打开筛选抽屉
    popupOpen () {
      this.temporaryList = JSON.parse(JSON.stringify(this.tagsList));
      this.popupShow = true;
    },
    // 抽屉确认
    popupSubmit () {
      this.tagsList = JSON.parse(JSON.stringify(this.temporaryList));
      this.init();
      this.popupShow = false;
    },
    // 标签handle
    handleTag (v) {
      if (!this.temporaryList.map((item) => item.id).includes(v.id)) {
        this.temporaryList.push(v);
      } else {
        this.temporaryList = this.temporaryList.filter((item) => item.id !== v.id);
      }
    },
    // 删除标签
    delTag (index) {
      this.tagsList.splice(index, 1);
      this.init();
    }

  }
};
</script>

<style lang="less" scoped>
#projectMember {
  height: 100%;
  display: flex;
  flex-direction: column;
  .headerBox {
    position: relative;
    width: 100%;
    height: 112px;
    padding: 20px 28px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .input {
      height: 72px;
      line-height: 32px;
      padding: 20px 32px 20px 0;
      flex: 1;
      background: #F7F8FA;
      border-radius: 36px;
      align-items: center;
      /deep/
      .van-field__label {
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #DDDEE6;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: space-around;
        .arrow {
          margin-left: 10px;
          width: 14px;
          height: 14px;
          transition: all .5s;
        }
        .arrowTop {
          transform:rotate(180deg);
          transition: all .5s;
        }
      }
    }
    .cencel {
      font-size: 28px;
      line-height: 44px;
      color: #333444;
      margin-left: 28px;
    }
  }
  .filterBox {
    height: 102px;
    padding: 0 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      flex: 1;
      width: 0;
      * {
        touch-action: pan-x;
      }
      .all {
        font-size: 28px;
        color: @primaryGreen;
      }
      .list {
        width: 100%;
        overflow: auto;
        display: flex;
        align-items: center;
        &::-webkit-scrollbar {
          display: none;
        }
        .item {
          flex-shrink: 0;
          margin-right: 20px;
          height: 48px;
          background: #F5FAFF;
          border: 1px solid #5FA9FF;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 16px;
          padding-right: 16px;
          span {
            word-break: keep-all;
            white-space: nowrap;
            font-size: 24px;
            color: #333444;
          }
          .icon-del {
            flex-shrink: 0;
            margin-left: 10px;
            width: 21px;
            height: 21px;
            background-image: url("~@/assets/images/research/icon_close_01.png");
          }
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      margin-left: 20px;
      span {
        font-size: 28px;
        color: #333444;
      }
      .icon {
        width: 40px;
        height: 40px;
      }
    }
  }
  .container {
    flex: 1;
    height: 0;
    overflow-y: auto;
  }
  .popupWrap {
    width: 598px;
    height: 100vh;
    background: #fff;
    border-radius: 16px 0px 0px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .list {
      flex: 1;
      height: 0;
      overflow-y: auto;
      .box {
        padding: 40px;
        .title {
          font-size: 28px;
          color: #333444;
        }
        .child {
          margin-top: 40px;
          display: flex;
          flex-wrap: wrap;
          .item {
            margin-bottom: 32px;
            margin-right: 25px;
            width: 156px;
            height: 62px;
            background-color: #F9F9F9;
            border-radius: 40px;
            font-size: 24px;
            color: #333;
            display: flex;
            align-items: center;
            justify-content: center;
            &:nth-child(3n) {
              margin-right: 0;
            }
          }
          .active {
            background-color: #E6FFF5;
            border: 2px solid #3AD498;
            color: #3AD498;
          }
        }
      }
    }
    .btnWrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 30px;
      padding-bottom: 50px;
      button {
        width: 470px;
        height: 80px;
        background: linear-gradient(90deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%);
        box-shadow: 0px 6px 12px rgba(79, 157, 255, 0.2);
        border-radius: 40px;
        font-size: 26px;
        color: #fff;
      }
    }
  }
}
</style>